var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutPro = function SvgCheckoutPro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#checkout-pro_svg__a)",
    d: "M12 22.154 8.996 19.18H4.82v-4.175L1.846 12l2.975-3.005V4.821h4.175L12 1.847l3.004 2.974h4.175v4.175l2.975 3.005-2.975 3.004v4.175h-4.175zm0-1.787 2.623-2.393h3.35v-3.35L20.366 12l-2.393-2.623v-3.35h-3.35L12 3.635 9.607 6.028h-3.58v3.35L3.634 12l2.393 2.622v3.35h3.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#checkout-pro_svg__b)",
    d: "m12.198 7.312.816 3.484a.26.26 0 0 0 .19.19l3.485.816c.21.049.21.348 0 .397l-3.485.816a.26.26 0 0 0-.19.19l-.816 3.484c-.048.21-.348.21-.396 0l-.816-3.484a.26.26 0 0 0-.19-.19l-3.485-.816c-.21-.049-.21-.348 0-.397l3.485-.816a.26.26 0 0 0 .19-.19l.816-3.484c.048-.21.348-.21.396 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "checkout-pro_svg__a",
    x1: 12,
    x2: 12,
    y1: 1.847,
    y2: 22.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0AE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49391E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "checkout-pro_svg__b",
    x1: 12,
    x2: 12,
    y1: 7.154,
    y2: 16.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0AE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49391E"
  })))));
};
export default SvgCheckoutPro;